import { FC } from 'react';
import styled from 'styled-components';
import trueImg from './assets/full.svg';
import falseImg from './assets/empty.svg';

const ProgressItem = styled.div`
  display: grid;
  grid-template-columns: 1fr max-content;
  grid-column-gap: 10px;
  margin-bottom: 9px;
`;

const ProgressText = styled.div(({ theme }) => {
  const { color, type } = theme;

  return `
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    font-family: ${type.face};
    color: ${color.grayscale[0]};
    font-size: ${type.size.tiny};
    line-height: 0.9rem;
  `;
});

const ProgressAchieved = styled.img`
  grid-column: 2;
  display: block;
  height: 33px;
  width: 33px;
`;

const TextOnlyProgress = styled.span(({ theme }) => {
  const { color, type } = theme;

  return `
    font-face: ${type.face};
    color: ${color.grayscale[0]};
    font-size: ${type.size.max};
    text-align: center;
    display: block;
  `;
});

type ProgressItem = {
  text: string;
  achieved: boolean;
};

export interface IAchievementProgress {
  progress: string | ProgressItem[] | undefined;
}

const AchievementProgress: FC<IAchievementProgress> = ({ progress }) => {
  if (typeof progress === 'string') {
    return <TextOnlyProgress>{progress}</TextOnlyProgress>;
  }

  if (typeof progress === 'undefined') {
    return <></>;
  }

  const progressLoop = progress.map((item, index) => {
    const { text, achieved } = item;
    const image = achieved ? trueImg : falseImg;
    const alt = achieved ? 'Achieved' : 'In Progress';

    return (
      <ProgressItem key={`progressItem-${index}`}>
        <ProgressText>{text}</ProgressText>

        <ProgressAchieved src={image} alt={alt} />
      </ProgressItem>
    );
  });

  return <>{progressLoop}</>;
};

export default AchievementProgress;
